import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { colors } from "../utils/datosTheme";

export default function QuickPeriodButtons({ preset, onPresetChange, compact = false }) {
  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={preset}
      onChange={(_, next) => onPresetChange(next)}
      sx={{
        flexWrap: "wrap",
        gap: compact ? 0.5 : 0.75,
        "& .MuiToggleButton-root": {
          border: `1px solid ${colors.line}`,
          borderRadius: "7px",
          color: colors.muted,
          px: 1.7,
          py: 0.8,
          minWidth: compact ? 0 : "auto",
          fontSize: 13,
          lineHeight: 1.2,
          fontWeight: 850,
          textTransform: "none",
          whiteSpace: "nowrap",
          "&.Mui-selected": {
            color: colors.ink,
            backgroundColor: "#eef5ff",
            borderColor: "#b8cff7",
          },
          "&.Mui-selected:hover": {
            backgroundColor: "#e5efff",
          },
        },
      }}
    >
      <ToggleButton value="month">Este mes</ToggleButton>
      <ToggleButton value="last3">Últimos 3 meses</ToggleButton>
      <ToggleButton value="year">Este año</ToggleButton>
    </ToggleButtonGroup>
  );
}
